/**
 * The admin token, in localStorage.
 *
 * Not a cookie: the API is on another origin and answers a bearer header, so
 * there is nothing a cookie would buy here that would not first need a
 * same-site proxy. The token lives twelve hours (`ADMIN_JWT_EXPIRES_IN`) and
 * the console throws it away the moment the API says `UNAUTHENTICATED`.
 */
export const TOKEN_KEY = 'talumi.admin.token';

export function readToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    // Private mode, or storage disabled entirely. Treat it as signed out
    // rather than taking the whole console down on boot.
    return null;
  }
}

export function writeToken(token: string): void {
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* see readToken */
  }
}

export function clearToken(): void {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* see readToken */
  }
}
